import type { AuthErrorCode } from '@gamble-chess/contracts';
import type { JSX } from 'react';

import { SIGN_IN_URL } from '../api/auth.ts';
import { AppShell } from '../components/AppShell.tsx';
import { Alert } from '../ui/Alert.tsx';
import { Card } from '../ui/Card.tsx';
import { primaryButtonClass } from '../ui/styles.ts';

const authErrorMessages: Readonly<Record<AuthErrorCode, string>> = {
  login_failed: 'Signing in did not work. Please try again.',
  login_expired: 'Your sign-in took too long or was interrupted. Please try again.',
};

export interface SignInProps {
  readonly authError: AuthErrorCode | undefined;
}

export function SignIn({ authError }: SignInProps): JSX.Element {
  return (
    <AppShell user={null}>
      <Card title="Chess results, in work-time">
        <p>
          Standing rules charge your own losses, wagers settle the next game against someone else,
          and the timer works the minutes off. No money is involved — only time you owe.
        </p>
        {authError === undefined ? null : <Alert>{authErrorMessages[authError]}</Alert>}
        <p>
          <a href={SIGN_IN_URL} className={primaryButtonClass}>
            Sign in
          </a>
        </p>
      </Card>
    </AppShell>
  );
}
